import type { FC } from "react";
import { useDispatch } from "react-redux";
import { hideDialog } from "../../Actions/DialogActions";
import Button from "../../Common/Button";
import CopyButton from "../../Common/CopyButton/CopyButton";

interface Props {
    clientId: string;
    secret: string;
}

/**
 * Shows a newly issued client secret. Secrets are hashed once stored, so this is the only time the plain
 * value can be displayed - afterwards only the prefix is shown.
 */
export const ApplicationSecret: FC<Props> = ({ clientId, secret }) => {
    const dispatch = useDispatch();

    return (
        <div className="application-details">
            <div className="rounded-lg bg-amber-500 text-white p-4 mb-4">
                <p className="font-bold">Copy your client secret now.</p>
                <p>
                    This is the only time we can show it to you - it&apos;s stored encrypted, so we
                    can&apos;t display it again. If you lose it you&apos;ll need to reset the secret and
                    update anywhere it&apos;s used.
                </p>
            </div>
            <h4 className="font-bold">Client ID<CopyButton text={clientId} /></h4>
            <code>{clientId}</code>
            <h4 className="font-bold">Client Secret<CopyButton text={secret} /></h4>
            <code>{secret}</code>
            <div className="dialog-buttons">
                <Button
                    type="button"
                    classes={[ "normal" ]}
                    onClick={() => dispatch(hideDialog())}
                >
                    I&apos;ve copied it
                </Button>
            </div>
        </div>
    );
};
